import React, { useState } from "react";

import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useTranslation } from "react-i18next";
import { IReceiptHeaderProps } from "./types";
import ReceiptToolbar from "./ReceiptToolbar";
import { useReceiptCardInfo } from "./handler/useReceiptCardInfo";
import { ClientType, OrderType } from "../../models/receipt/receipt";

const ReceiptHeader: React.FC<IReceiptHeaderProps> = ({
  data,
  orderStatus,
  onHelpClick,
  dashTaxiPhone = process.env.REACT_APP_CONTACT_SUPPORT || "+852 6433 0388",
  dashTaxiTime = "(6am - 10pm)",
  hotelTime = "(24 hours)",
}) => {
  const { hotelPhone, clientType, isShowSupportContact, type } =
    useReceiptCardInfo(orderStatus, data);
  const [showModal, setShowModal] = useState(false);
  // const { t } = useTranslation();
  const { t } = useTranslation("webReceipt");

  const handleHelpClick = () => {
    setShowModal(true);
    if (onHelpClick) onHelpClick();
  };
  const handleCloseModal = () => setShowModal(false);

  return (
    <>
      <ReceiptToolbar handleHelpClick={handleHelpClick} />
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
          <div className="bg-white rounded-2xl  p-8 w-full max-w-[400px] mx-2 flex flex-col gap-6 relative">
            <button
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
              onClick={handleCloseModal}
              aria-label={t("close")}
            >
              <span className="text-2xl font-bold">&times;</span>
            </button>
            <div className="text-2xl font-bold text-gray-900 mb-4">
              {t("supportlModalTitle")}
            </div>
            <div className="flex items-center justify-between mb-2">
              <div>
                <div className="font-bold text-lg text-gray-800">
                  {t("supportlModalDASHTaxi")}
                </div>
                <div className="text-gray-400 text-base">
                  {dashTaxiPhone} <span className="ml-1">{dashTaxiTime}</span>
                </div>
              </div>
              <div className="flex gap-3">
                <a
                  href={`tel:${dashTaxiPhone.replace(/\s/g, "")}`}
                  className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center"
                >
                  <PhoneIcon sx={{ color: "#2563eb", fontSize: 25 }} />
                </a>
                <a
                  href={`https://wa.me/${dashTaxiPhone.replace(/\s/g, "")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-100 rounded-full w-12 h-12 flex items-center justify-center"
                >
                  <WhatsAppIcon sx={{ color: "#22c55e", fontSize: 25 }} />
                </a>
              </div>
            </div>
            {clientType === ClientType.B2B_APP &&
              type === OrderType.HAILING_REQUEST &&
              isShowSupportContact && (
                <>
                  <hr className="border-gray-200 my-2" />
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="font-bold text-lg text-gray-800">
                        {t("supportlModalHotelReception")}
                      </div>
                      <div className="text-gray-400 text-base">
                        {hotelPhone} <span className="ml-1">{hotelTime}</span>
                      </div>
                    </div>
                    <div className="flex gap-3">
                      <a
                        href={`tel:${hotelPhone.replace(/\s/g, "")}`}
                        className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center"
                      >
                        <PhoneIcon sx={{ color: "#2563eb", fontSize: 25 }} />
                      </a>
                    </div>
                  </div>
                </>
              )}
          </div>
        </div>
      )}
    </>
  );
};

export default ReceiptHeader;
